import { call, fork, put, take } from 'redux-saga/effects';
import api from 'services';
import * as actionTypes from 'constants/ActionTypes';

/**
 * Delete cargo name
 * */
function* getCargoTagsCategories() {
    try {
        const response = yield call(api.getTagsCategories);

        if (response && (!response.errors || !response.errors.length)) {
            yield put({
                type: actionTypes.GET_CARGO_TAGS_CATEGORIES.SUCCESS,
                data: response.data,
            });
            return;
        }

        yield put({
            type: actionTypes.GET_CARGO_TAGS_CATEGORIES.FAILURE,
            errors: response.errors,
        });
    } catch (e) {
        yield put({
            type: actionTypes.ADD_NOTIFICATION,
            notification: {
                title: 'Error',
                message: 'Something went wrong',
                level: 'error',
                _id: new Date().getMilliseconds(),
                autoDismiss: 2,
            },
        });
    }
}

export function* watchCargoTagsCategories() {
    while (true) {
        yield take(actionTypes.GET_CARGO_TAGS_CATEGORIES.REQUEST);
        yield fork(getCargoTagsCategories);
    }
}

export default [
    watchCargoTagsCategories,
];



// WEBPACK FOOTER //
// ./app/sagas/cargoes/tags.js